// 配車画面（V3Plans / V3Timeline / ConvenienceDispatches）共通の割当ラベル。
// トラック未設定（temporary/未指定）は「車両未設定」、ドライバー未設定（temporary/未指定）は「ドライバー未設定」。
// 未設定系テキストはグレーで表示する。
export const UNSET_LABEL_COLOR = '#4B5563';
export const TRUCK_UNSET_LABEL = '車両未設定';
export const DRIVER_UNSET_LABEL = 'ドライバー未設定';

// 未設定を示す表示ラベル。トラック=「車両未設定」、ドライバー=「ドライバー未設定」。
export const UNSET_LABELS: readonly string[] = [TRUCK_UNSET_LABEL, DRIVER_UNSET_LABEL];

// 表示ラベルが未設定系ならグレー色、そうでなければ undefined を返す。
// 未設定の実体は temporary=true の場合と temporary=false のフォールバック entity の場合があり
// フラグでは判定できないため、最終的な表示文字列で判定する。
export const unsetColorFor = (label?: string | null): string | undefined => (
  label && UNSET_LABELS.includes(label) ? UNSET_LABEL_COLOR : undefined
);
